<template>
  <div>
    <app-header no_back="true" settings="systemZoom">esma</app-header>


    <div class="menu" style="">
      <div class="row" style="margin: 30px;min-width: 1100px;">
        <div class="col-xs-3" style="">
          <router-link
            :disabled="checkMenuUserPermission(acl.device_embedded_information,permissionMode.BROWSE) == false" tag="button"
            to="/device_embedded_information"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >機器・組込情報</router-link>
          <router-link
            :disabled="checkMenuUserPermission(acl.certificate_information,permissionMode.BROWSE) == false && checkMenuUserPermission(acl.surplus_license,permissionMode.BROWSE) == false" tag="button"
            to="/menu_certificate"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >証書</router-link>
          <router-link
            :disabled="checkMenuUserPermission(acl.approval_history,permissionMode.BROWSE) == false" tag="button"
            to="/approval_history"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >申請承認</router-link>
          <router-link
            :disabled="checkMenuUserPermission(acl.inventory,permissionMode.BROWSE) == false" tag="button"
            to="/menu_inventory"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >棚卸</router-link>
          <router-link
            :disabled="checkMenuUserPermission(acl.bulk_import,permissionMode.BROWSE) == false && checkMenuUserPermission(acl.bulk_import2,permissionMode.BROWSE) == false" tag="button"
            to="/bulk_import"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >一括取込</router-link>
          <router-link
            :disabled="checkMenuUserPermission(acl.master_user_password,permissionMode.BROWSE) == false && checkMenuUserPermission(acl.master_user,permissionMode.BROWSE) == false" tag="button"
            to="/menu_master"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >ユーザ</router-link>
          <router-link
            :disabled="checkMenuUserPermission(acl.master_bel_mak_sys,permissionMode.BROWSE) == false" tag="button"
            to="/menu_configuration"
            type="button"
            style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
            class="btn btn-primary btn-lg"
            >管理・マスタ</router-link>
          <router-link
          :disabled="checkMenuUserPermission(acl.maintenance,permissionMode.BROWSE) == false" tag="button"
          to="/menu_maintenance"
          type="button"
          style="min-width:100px;margin: 5px; width: 80%;background: #3b89cd;color: white;font-weight: bold;"
          class="btn btn-primary btn-lg">
          メンテナンス</router-link>

        </div>
        <div class="col-xs-4" style="font-size: 13px;">
          <div class="box" v-if="isUserIDOperationInCharge == false">



            <div class="box-title">■通知</div>
            <p>
              ■ライセンス情報
              <br />
              <table class="counters"> 
                <tr class="counters">
                  <td class="counters_first">・３ヵ月以内に有効期限が切れるライセンス　</td>
                  <td class="counters"><input
                  :disabled="true"
                  style=" "
                  class="menu_input_box" 
                  :value="certificateThatExpiresIn3Months" />件
                </td>
                  <td class="counters"><router-link
                  to="/notification_certificate/certificate_3_months"
                  type="button"
                  style="min-width:50px;width: 10%"
                  class="btn btn-primary btn-sm"
                  >詳細</router-link></td>
                </tr>
                <tr class="counters">
                  <td class="counters_first">・有効期限切れライセンス　</td>
                  <td  class="counters"> <input
                  :disabled="true"
                  style=" "
                  class="menu_input_box" 
                  :value="certificateExpiredLicense" />件
                </td>
                  <td class="counters"> <router-link
                    to="/notification_certificate/certificate_expired"
                    type="button"
                    style="min-width:50px;width: 10%"
                    class="btn btn-primary btn-sm"
                    >詳細</router-link></td>
                </tr>
              </table>

              <p>
              ■未承認申請情報
              <br />
              <table class="counters"> 
                <tr class="counters">
                  <td class="counters_first">・申請承認（申請中）</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="applicationApprovalPending" />件
            </td>
                  <td class="counters"> <router-link
              to="/approval_history"
              type="button"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</router-link></td>
                </tr>
                <tr class="counters">
                  <td class="counters_first">・申請承認（差戻）</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="applicationApprovalRejection" />件
            </td>
                  <td class="counters"><router-link
              to="/approval_history/rejected"
              type="button"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</router-link></td>
                </tr>
              <tr class="counters">
                  <td class="counters_first">・一括取込（申請中）</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="bulkImportPending" />件
            </td>
                  <td class="counters"><router-link
              to="/approval_history/all"
              type="button"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</router-link></td>
                </tr>
                <tr class="counters">
                  <td class="counters_first">・一括取込（差戻）</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="bulkImportRejection" />件
            </td>
                  <td class="counters"><router-link
              to="/approval_history/all/rejected"
              type="button"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</router-link></td>
                </tr>
              </table>
              </p>

              <p v-if="applicationApprovalInventoryPending > 0 || applicationApprovalInventoryRejection > 0">
              ■棚卸情報
              <br />
              <table class="counters"> 
                <tr class="counters"  v-if="applicationApprovalInventoryPending > 0">
                  <td class="counters_first">・申請承認（申請中）</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="applicationApprovalInventoryPending" />件
            </td>
                  <td class="counters"> <button
              @click="applicationApprovalInventoryBtn"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</button></td>
                </tr>
                <tr class="counters" v-if="applicationApprovalInventoryRejection > 0">
                  <td class="counters_first">・申請承認（差戻）</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="applicationApprovalInventoryRejection" />件
            </td>
                  <td class="counters"><button
              @click="applicationApprovalInventoryRejectionBtn"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</button></td>
                </tr>
              </table>
              </p>


          </div>
           <div class="box" style="margin-top:30px;min-height:200px;" v-if="isMultiCompanyAdmin">
            <div class="box-title">■余剰ライセンス</div>
            <p>
              <table class="counters"> 
                <tr class="counters">
                  <td class="counters_first">・3ヵ月以内に有効期限が切れる余剰ライセンス</td>
                  <td  class="counters"><input
              :disabled="true"
              style=" "
              class="menu_input_box" 
              :value="surplusLicenseThatExpiresIn3Months" />件
            </td>
                  <td class="counters"><router-link
              to="/notification_certificate/surplus_3_months"
              type="button"
              style="min-width:50px;width: 10%"
              class="btn btn-primary btn-sm"
              >詳細</router-link></td>
                </tr>
                <tr class="counters">
                  <td class="counters_first">・有効期限切れ余剰ライセンス</td>
                  <td  class="counters"><input
                    :disabled="true"
                    style=" "
                    class="menu_input_box" 
                    :value="surplusExpiredLicense" />件
                  </td>
                  <td class="counters"><router-link
                    to="/notification_certificate/surplus_expired"
                    type="button"
                    style="min-width:50px;width: 10%"
                    class="btn btn-primary btn-sm"
                    >詳細</router-link>
                  </td>
                </tr>
              </table>
            </p>
          </div>

            <!--<div class="box" style="margin-top:30px;min-height:150px;" v-if="isMultiCompanyAdmin && disablePwLink == false">
            <div class="box-title">■PWロック解除申請</div>
              <p>
                <table class="counters"> 
                  <tr class="counters">
                    <td class="counters_first">・PWロック解除(申請中)</td>
                    <td  class="counters"> <input
                      :disabled="true"
                      style=" "
                      class="menu_input_box" 
                      :value="pwApprovalHistory" />件
                    </td>
                    <td class="counters">
                      <router-link
                      v-if="disablePwLink == false"
                      to="/pw_approval_history/pending"
                      type="button"
                      style="min-width:50px;width: 10%"
                      class="btn btn-primary btn-sm"
                      >詳細</router-link>
                    </td>
                  </tr>
                </table>
              </p>
          </div>-->
        </div>
        <div class="col-xs-4">
          <info-box title="■ライセンス管理窓口からのご案内"  box_id="home_box1" />
          <info-box title="■ e-sma操作マニュアル・フロー図" box_id="home_box2"/>
        </div>
      </div>
    </div>
    <notice-modal tag="processNoticeModal"/>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import MenuBtn from "../components/menu-btn";
import { utils } from "@/libs/utils";
import mixinMenuCommon from "@/mixins/mixin_menu_common";
import mixinPageCommon from '@/mixins/mixin_page_common';
import noticeModal from "../components/modals/notice-modal";
import infoBox from "../components/info-box";

import debug from "debug";
var debug_menu = debug("esma:menu");

Vue.component("menu-btn", MenuBtn);

import { bus } from "@/libs/bus";

export default {
  mixins: [mixinMenuCommon,mixinPageCommon],
  components: {
    "notice-modal":noticeModal,
    "info-box":infoBox
  },
  //  name: 'Name here',
  data() {
    return {
      notification_certificate_over_qty:"~",
      notification_certificate_qty:"~",
      approval_history_qty:"~",
      approval_history_all_qty:"~",

      certificate_that_expires_in_3_months:"^",
      certificate_expired_license:"^",
      application_approval_pending:"^",
      application_approval_rejection:"^",
      application_approval_inventory_pending:"^",
      application_approval_inventory_rejection:"^",
      bulk_import_pending:"^",
      bulk_import_rejection:"^",
      surplus_license_that_expires_in_3_months:"^",
      surplus_expired_license:"^",
      pw_approval_history:"^",
      approval_sub_search:{},
      reject_sub_search:{},
    };
  },

  computed: {
    disablePwLink(){
      return this.checkMenuUserPermission(this.acl.master) == false || utils.constants.COMPANY.ALL != Vue.localStorage.get("selectedCompany")
    },
    certificateThatExpiresIn3Months:{
      get(){
        return this.certificate_that_expires_in_3_months;
      },
      set(v){
        this.certificate_that_expires_in_3_months = v;
      }
    },
    certificateExpiredLicense:{
      get(){
        return this.certificate_expired_license;
      },
      set(v){
        this.certificate_expired_license = v;
      }
    },
    applicationApprovalPending:{
      get(){
        return this.application_approval_pending;
      },
      set(v){
        this.application_approval_pending = v;
      }
    },
    applicationApprovalRejection:{
      get(){
        return this.application_approval_rejection;
      },
      set(v){
        this.application_approval_rejection = v;
      }
    },
    applicationApprovalInventoryPending:{
      get(){
        return this.application_approval_inventory_pending;
      },
      set(v){
        this.application_approval_inventory_pending = v;
      }
    },
    applicationApprovalInventoryRejection:{
      get(){
        return this.application_approval_inventory_rejection;
      },
      set(v){
        this.application_approval_inventory_rejection = v;
      }
    },
    bulkImportPending:{
      get(){
        return this.bulk_import_pending;
      },
      set(v){
        this.bulk_import_pending = v;
      }
    },
    bulkImportRejection:{
      get(){
        return this.bulk_import_rejection;
      },
      set(v){
        this.bulk_import_rejection = v;
      }
    },
    surplusLicenseThatExpiresIn3Months:{
      get(){
        return this.surplus_license_that_expires_in_3_months;
      },
      set(v){
        this.surplus_license_that_expires_in_3_months = v;
      }
    },
    pwApprovalHistory:{
      get(){
        return this.pw_approval_history;
      },
      set(v){
        this.pw_approval_history = v;
      }
    },
    surplusExpiredLicense:{
      get(){
        return this.surplus_expired_license;
      },
      set(v){
        this.surplus_expired_license = v;
      }
    },

    },
  created() {},
  methods: {
    loadAllCounters(cb){
      console.log('TEST DEBUG 210427 (377 at menu.vue)[21:50]: IS COUNTING', {  });
      this.$ajax.post('/common/load_menu_counters/', {}, (err, result) => {
        cb(err,result);
      })
    },
    applicationApprovalInventoryBtn(){
      return this.$router.push({
        name: 'page_0072_inventory_report_check',
        params: { sub_search: this.approval_sub_search }
      });
    },
    applicationApprovalInventoryRejectionBtn(){
      return this.$router.push({
        name: 'page_0072_inventory_report_check',
        params: { sub_search: this.reject_sub_search }
      });
    },
  },
  mounted() {
    // if(this.isUserIDOperationInCharge == false){
      this.loadAllCounters((err,result)=>{
        if(err){
            return this.$notify({
              text: err,
              type: 'error',
              duration: 10000
            });
        }
        this.certificateThatExpiresIn3Months = result.certificate_that_expires_in_3_months
        this.certificateExpiredLicense = result.certificate_expired_license
        this.applicationApprovalPending = result.application_approval_pending
        this.applicationApprovalRejection = result.application_approval_rejection
        this.bulkImportPending = result.bulk_import_pending
        this.bulkImportRejection = result.bulk_import_rejection
        this.surplusLicenseThatExpiresIn3Months = result.surplus_license_that_expires_in_3_months
        this.surplusExpiredLicense = result.surplus_expired_license
        this.pwApprovalHistory = result.pw_approval_history;
        this.applicationApprovalInventoryPending = result.application_approval_inventory_pending
        this.applicationApprovalInventoryRejection = result.application_approval_inventory_rejection
      
        if(this.applicationApprovalInventoryPending > 0){
          this.approval_sub_search = {
            company:result.approval_company,
            reporting_period:result.approval_reporting_period,
            jurisdiction_classification:"棚卸申請承認"
          }
        }
        if(this.applicationApprovalInventoryRejection > 0){
          this.reject_sub_search = {
            company:result.reject_company,
            reporting_period:result.reject_reporting_period,
            jurisdiction_classification:result.reject_jurisdiction_classification
          }
        }

        if(this.disablePwLink){
          delete result.pw_approval_history;
        }
        return bus.$emit("processNoticeModal",{all_counters:result});
      });
    // }
    this.$ajax.post('/ping', {}, (err, response) => {
        console.log("Ping response",{err,response})
    })
  },
};
</script>
<style scoped>

table.counters {
  width: 100%;
  
}
td.counters {
  min-width: 50px;
  padding: 10px 2px;
  white-space: nowrap;
}
td.counters_first {
  width: 100%;
  padding: 5px 2px;
}
tr.counters {
 _border: solid 1px black;
}
.menu_input_box {
  text-align: end;
  border: solid #337ab7 1px;
  width: 60px; 
  padding-left:4px;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
}
.menu {
  text-align: center;
}

.menu-btns {
  text-align: center;
  padding: 0px;
}

.menu-btns-container {
  text-align: center;
  max-width: 1100px;
  margin: auto;
  padding: 0px;
}

.box {
    margin-top: 5px;
    background: #FFFFFF;
    border: 1px solid #337ab7;
    border-radius: 5px;
    min-height: 450px;

}
.box .box-title {
    background: #bdd6ec;
    padding: 4px;
    text-align: left;
    font-weight: bold;
    letter-spacing: 0.05em;
    border-radius: 5px 5px 0 0;
}
.box p {
    padding: 15px 20px;
    margin: 0;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// menu.vue?3a93b3e9